import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tabs } from "antd";
import { OCTOLANE_COLOR_TOKENS } from "~/app/styles/tokens";

import If from "~/core/ui/If";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";

import { COMMANDBAR_FILTER_TABS } from "../../constants/common";
import { useGlobalCommandbarStore } from "../../store";
import type { CommandbarFilterTabType } from "../../types/common";

const StyledTabs = styled(Tabs)`
  & > .ant-tabs-nav {
    margin-bottom: 0px !important;

    .ant-tabs-nav-wrap {
      padding-inline: 20px;

      .ant-tabs-nav-list > .ant-tabs-tab {
        padding-top: 0px;
        color: ${OCTOLANE_COLOR_TOKENS.text.light};

        &:hover {
          color: ${OCTOLANE_COLOR_TOKENS.text.dark} !important;
        }
      }
    }
  }

  :where(.css-dev-only-do-not-override-uuuxml).ant-tabs-top
    > .ant-tabs-nav::before,
  :where(.css-dev-only-do-not-override-uuuxml).ant-tabs-bottom
    > .ant-tabs-nav::before,
  :where(.css-dev-only-do-not-override-uuuxml).ant-tabs-top
    > div
    > .ant-tabs-nav::before,
  :where(.css-dev-only-do-not-override-uuuxml).ant-tabs-bottom
    > div
    > .ant-tabs-nav::before {
    border-bottom: 1px solid ${OCTOLANE_COLOR_TOKENS.border.light};
  }
`;

export default function CommandbarFilterTabs() {
  const activeFilterTab = useGlobalCommandbarStore(st => st.activeFilterTab);
  const setActiveFilterTab = useGlobalCommandbarStore(
    st => st.setActiveFilterTab,
  );
  const searchInputRef = useGlobalCommandbarStore(st => st.searchInputRef);

  return (
    <StyledTabs
      activeKey={activeFilterTab}
      onChange={tab => {
        setActiveFilterTab(tab as CommandbarFilterTabType);
        searchInputRef?.current?.focus();
      }}
      items={COMMANDBAR_FILTER_TABS.map(tabItem => {
        return {
          key: tabItem.label,
          label: (
            <div key={tabItem.label} className="flex items-center gap-1">
              <If condition={!!tabItem.icon}>
                <FontAwesomeIcon icon={tabItem.icon as IconProp} />
              </If>
              {tabItem.label}
            </div>
          ),
        };
      })}
      indicator={{
        size: (origin: number) => {
          return origin + 12;
        },
      }}
    />
  );
}
